import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './dashboard-left.styl'

export default class DashboardLeft extends Component {
  static propTypes = {
    children: PropTypes.any,
    isSmDetail: PropTypes.bool.isRequired
  }

  render() {
    const { isSmDetail } = this.props

    const classNames = [styles.left]

    isSmDetail && classNames.push(styles.active)

    return (
      <div className={classNames.join(' ')}>
        <div className={styles.inner}>{this.props.children}</div>
      </div>
    )
  }
}
